export const UserCategory = Object.freeze({
  PATIENT: 2,
  CLIENT: 3,
});
